import { styled } from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 460px;
  padding: 64px 50px;
  flex-direction: column;
  align-items: center;
  gap: ${props => (props.$gap ? '54px' : '32px')};
  border-radius: 24px;
  background: #fffdfc;
  box-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.04);
  @media (max-width: 540px) {
    width: 100%;
  }
`;

export const Message = styled.span`
  text-align: center;
  font-feature-settings: 'case' on;
  font-family: 'Poppins-Regular';

  font-size: 20px;

  line-height: 30px; /* 150% */
  letter-spacing: -0.408px;
`;

export const WidthMessage = styled(Message)`
  width: 302px;
  @media (max-width: 540px) {
    width: 100%;
  }
`;

export const Subtitle = styled.span`
  color: #000;
  text-align: center;
  font-feature-settings: 'case' on;
  font-family: 'Playfair Display';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  opacity: 0.56;
`;

export const Top = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
`;
